import { useMemo } from 'react';
import { useEvent } from '../eventHooks';

/**
 * Returns true if the event has the schedule feature enabled
 * @param {number} eventId
 */
export function useScheduleEnabled(eventId) {
    const event = useEvent(eventId);
    return useMemo(() => !event?.settings?.disable_schedule, [event?.settings]);
}
